import Splide from '@splidejs/splide';
import { Intersection } from '@splidejs/splide-extension-intersection';

export const initHelpSlider = () => {
  const contentBoxSliders = document.querySelectorAll(
    '[data-discount-code-template-help-box-slider]'
  );

  contentBoxSliders.forEach((contentBoxSlider) => {
    const contentBoxSliderSplide = new Splide(contentBoxSlider, {
      type: 'fade',
      rewind: true,
      perPage: 1,
      autoplay: true,
      pauseOnHover: true,
      pauseOnFocus: true,
      interval: 3000,
      speed: 1200,
      drag: true,
      arrows: true,
      pagination: true,
      cssEase: 'linear',
      intersection: {
        inView: {
          autoplay: true,
        },
        outView: {
          autoplay: false,
        },
      },
      classes: {
        pagination:
          'discount-code-template-help__box-slider-pagination splide__pagination',
        page: 'discount-code-template-help__box-slider-pagination-btn splide__pagination__page',
      },
    });

    contentBoxSliderSplide.mount({ Intersection });

    const mobileArrows = contentBoxSlider.querySelectorAll(
      '[data-discount-code-template-help__box-slider-slide-content-copy-arrow]'
    );

    mobileArrows.forEach((mobileArrow) => {
      mobileArrow.addEventListener('click', () => {
        const arrowDirection = mobileArrow.getAttribute(
          'data-discount-code-template-help__box-slider-slide-content-copy-arrow'
        );
        const activeSLide = contentBoxSliderSplide.index;

        if (arrowDirection === 'next') {
          const nexSlide =
            activeSLide === contentBoxSliderSplide.length - 1
              ? 0
              : activeSLide + 1;

          contentBoxSliderSplide.go(nexSlide);
        } else {
          const prevSlide =
            activeSLide === 0
              ? contentBoxSliderSplide.length - 1
              : activeSLide - 1;

          contentBoxSliderSplide.go(prevSlide);
        }
      });
    });
  });

  const tabs = document.querySelectorAll(
    '[data-discount-code-template-help-tab]'
  );
  const contentBoxes = document.querySelectorAll(
    '[data-discount-code-template-help-box]'
  );

  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => {
      const activeTab = document.querySelector(
        '[data-discount-code-template-help-tab][data-active="true"]'
      );
      const activeContentBox = document.querySelector(
        '[data-discount-code-template-help-box][data-active="true"]'
      );

      tab.setAttribute('data-active', 'true');
      activeTab.setAttribute('data-active', 'false');
      contentBoxes[index].setAttribute('data-active', 'true');
      activeContentBox.setAttribute('data-active', 'false');
    });
  });
};
